import { ReloadOutlined } from '@ant-design/icons'
import { Alert, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { translateError } from '@/shared/api/errors'

interface LoadErrorProps {
  /**
   * NIMA yuklanmagani — `plans.loadFailed`, `usage.loadFailed` va h.k.
   * ⚠️ Kalit, tayyor matn EMAS: xom satr bu yerga tushsa u tarjima
   * qatlamidan o'tmaydi (§23.6 dagi `client.ts` tuzog'ining aynan o'zi).
   */
  titleKey: string
  error: unknown
  /**
   * So'rovni qaytadan yuborish — odatda `query.refetch()`.
   *
   * ⚠️ MAJBURIY, va bu ataylab. Ixtiyoriy bo'lganda chaqiruvchi uni
   * jimgina tashlab ketardi va ekran yana tugmasiz qolardi — aynan shu
   * holat 2026-08-20 auditida oltita sahifada topilgan. Majburiy
   * bo'lgach, chiqish yo'lisiz yangi xato ekrani KOMPILYATSIYADAN
   * o'tmaydi.
   */
  onRetry: () => void
}

/**
 * Ma'lumot yuklanmaganda ko'rsatiladigan xato.
 *
 * <h2>⚠️ NEGA ALOHIDA KOMPONENT — «hammasi bir xil ko'rinardi»</h2>
 *
 * Ilgari har sahifada shunday yozilardi:
 *
 * <pre>{@code <Alert type="error" showIcon message={translateError(err, t)} />}</pre>
 *
 * `translateError` esa NIMA yuklanmaganini BILMAYDI — u faqat HTTP
 * holatini biladi. Ya'ni tarmoq uzilganda abonent BEShTA sahifada ham
 * aynan bitta jumlani ko'rardi: «Serverga ulanib bo'lmadi…».
 *
 * ⚠️ Bosh sahifada bu ayniqsa yomon edi: u IKKI mustaqil so'rov yuboradi
 * (balans va trafik), ya'ni bitta ekranda IKKITA bir xil qizil qutini
 * yonma-yon ko'rsatishi mumkin edi. Qaysi biri nima haqida ekanini
 * ekrandan bilib bo'lmasdi — balansim yo'qmi, grafikmi, ikkalasimi?
 *
 * ⚠️ Eng achinarlisi: matnlar ALLAQACHON uch tilda yozilgan va turgan
 * edi (`plans.loadFailed`, `usage.loadFailed`, `sessions.loadFailed`,
 * `payments.loadFailed`, `dashboard.loadFailed`) — beshtasi ham
 * kodning HECH BIR joyidan chaqirilmasdi. Ya'ni tarjimon ishlagan,
 * matn yozilgan, ekranga esa chiqmagan.
 *
 * <h2>⚠️ TUGMA — o'sha shikoyatning IKKINCHI qatlami</h2>
 * `common.retry` ("Qayta urinish") ham uch tilda yozilib, kodning hech
 * bir joyidan chaqirilmasdi. Natijada abonentning yagona chorasi F5
 * bosish edi — va `Paketlar`, `To'lovlar`, `Trafik` sahifalarida
 * avtoyangilanish ham yo'q, ya'ni ekran qizil qutida QOTIB qolardi.
 *
 * ⚠️ BU KOMPONENT FAQAT YUKLASH XATOSI UCHUN. Serverning ANIQ RAD
 * javobi (masalan "mablag' yetmadi") bu yerga TUSHMAYDI va tushmasligi
 * kerak: u yerda qayta urinish hech qachon yordam bermaydi va tugma
 * abonentni foydasiz halqaga tortardi. Rad javobi o'z joyida, o'z
 * chiqish yo'li bilan ko'rsatiladi (`PlansPage`).
 *
 * <h2>Shakl — sarlavha va sabab ajratilgan (§23.2, 3-qoida)</h2>
 * «nima bo'ldi» sarlavhada («Paketlar ro'yxatini yuklab bo'lmadi»),
 * «nega va nima qilish kerak» pastida («Internetni tekshirib,
 * qayta urining»). Ikkalasini bitta qatorga qo'shib yuborish uzun,
 * o'qilmaydigan jumla berardi.
 */
export function LoadError({ titleKey, error, onRetry }: LoadErrorProps) {
  const { t } = useTranslation()
  return (
    <Alert
      type="error"
      showIcon
      message={t(titleKey)}
      description={translateError(error, t)}
      action={
        <Button size="small" icon={<ReloadOutlined />} onClick={onRetry}>
          {t('common.retry')}
        </Button>
      }
    />
  )
}
